<div
  class="task-item row no-gutters d-flex justify-content-between full-height"
>
  <div class="task-buttons d-flex justify-content-end align-items-center">
    <div
      class="d-flex justify-content-between flex-row"
      *ngIf="!disabled; else viewButton"
    >
      <div>
        <button
          mat-icon-button
          color="accent"
          matTooltip="Edit Task"
          (click)="edit(false)"
        >
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          matTooltip="Duplicate Task"
          (click)="duplicate.emit(task)"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
        <button
          mat-icon-button
          color="warn"
          (click)="delete.emit(task)"
          matTooltip="Delete Task"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>

    <ng-template #viewButton>
      <button mat-icon-button (click)="edit(true)" matTooltip="View">
        <mat-icon color="primary">visibility</mat-icon>
      </button>
    </ng-template>
  </div>
  <div
    class="col-12 align-items-center"
    [ngClass]="{
		'task-error': service.hasErrors(),
	  }"
  >
    <div class="task-actions">
      <span
        *ngFor="let action of actions"
        class="action-arrow to-step-{{ action.wfNextStepConfigID }}"
        [ngClass]="{
          blue: action.action == 1,
          red: action.action == 2,
          yellow: action.action == 3
        }"
      ></span>
    </div>
    <div class="task-icons d-flex flex-row justify-content-end">
      <mat-icon
        class="small-icon"
        color="primary"
        *ngIf="s.requesterSignature"
        matTooltip="Is Requester Signature"
        >how_to_reg</mat-icon
      >
      <mat-icon
        class="small-icon"
        color="accent"
        *ngIf="s.code"
        [matTooltip]="s.code"
        >local_offer</mat-icon
      >
      <mat-icon
        class="pink small-icon"
        *ngIf="s.condition"
        [matTooltip]="s.condition"
        >device_hub</mat-icon
      >
      <mat-icon
        class="small-icon material-symbols-outlined"
        [ngClass]="getConfigValue(s.configuration) + '-task'"
        *ngIf="s.configuration || s.condition"
        [matTooltip]="
          'If NOT Conditions met: ' +
          getConfigValue(s.configuration).toUpperCase()
        "
        >disabled_visible</mat-icon
      >
    </div>
    <master-control
      [id]="s.id"
      [type]="s.type"
      [builder]="true"
      [editor]="false"
      [visible]="true"
      [disabled]="true"
      [enabled]="true"
      [color]="s.cssClass ?? 'primary'"
      [number]="s.number"
      [header]="s.name"
      [label]="s.name"
      [text]="s.question"
      [question]="s.question"
      [radioQuestion]="s.question2"
      [options]="s.options"
      [color]="s.color!"
      [radioOptions]="s.options"
      [checkbox_checked]="s.approved"
      [approved]="s.approved"
      [approvedBy]="s.approvedBy"
      [approvedOn]="s.approvedOn"
      [roleIds]="s.roles"
      [roleCodes]="s.roleCodes"
      [scheduleResourceId]="s.scheduleResourceId"
      [scheduleTypeId]="s.scheduleTypeId"
      [textBefore]="
        componentsToSwapText.includes(s.type ?? 0) ? s.question2 : s.question
      "
      [textAfter]="
        componentsToSwapText.includes(s.type ?? 0) ? s.question : s.question2
      "
      [textAfter2]="s.question3"
      [textValue]="s.textValue"
      [checkboxVisible]="s.visible != undefined ? s.visible : true"
      [disableEdit]="true"
      [dateValue1]="s.dateValue1"
      [dateValue2]="s.dateValue2"
      [dateValue3]="s.dateValue3"
      [configuration]="s.configuration"
      [editMode]="s.editMode"
      style="width: 100%"
    >
    </master-control>
    <div
      class="warning"
      *ngIf="service.hasErrors()"
      [matTooltip]="errorMessage"
      matTooltipClass="warn-tooltip"
      matTooltipPosition="right"
    >
      <mat-icon color="warn">warning</mat-icon>
    </div>
  </div>
</div>
